import React from 'react';

import { FlexLink } from '../../shared';

interface BannerProps {
  contentText: string;
  link?: string;
  linkText?: string;
}

const Banner = ({ contentText, link, linkText }: BannerProps) => {
  return (
    <div className="Banner">
      <span className="content track-click">
        <p>{contentText}</p>
      </span>
      {link && (
        <FlexLink href={link} className="button banner-button">
          {linkText}
        </FlexLink>
      )}
    </div>
  );
};

export default Banner;
